/* eslint-disable */ import { assertNumber, distanceDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const squarePlateComponents = [
    attachComponent.withComponent(distanceDimensionComponent, 'sideLength', true).withEntity('SquarePlate').attach(memoEval((self)=>[
            self.sideLength,
            self.$minSideLength,
            self.$maxSideLength
        ], (sideLength, $minSideLength, $maxSideLength)=>({
            value: sideLength,
            min: $minSideLength,
            max: $maxSideLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            sideLength: state.value
        };
    })
];

//# sourceMappingURL=square-plate.js.map